class ArchiveNews {
  constructor() {
    this._init();
  }

  _init() {
    const archive = document.querySelector(
      '.archive-news'
    );

    if (archive) {
      const loadMoreButton = document.querySelector('[data-toggle-readmore-news') as HTMLButtonElement;

      if (loadMoreButton) {
        loadMoreButton.addEventListener('click', async () => {
          // Récupérer la page actuelle depuis l'attribut data-page
          const currentPage = parseInt(loadMoreButton.getAttribute('data-page') || '1', 10);
          const nextPage = currentPage + 1;

          const urlParams = new URLSearchParams(window.location.search);
          const entreprise = urlParams.get('entreprise') || '';
          const categorie = urlParams.get('categorie') || '';

          const formData = new FormData();
          formData.append("action", "load_more_news");
          formData.append("page", nextPage.toString());
          formData.append("nonce", (window as any).ajax.nonce);
          if (entreprise) {
            formData.append("entreprise", entreprise);
          }
          if (categorie) {
            formData.append("categorie", categorie);
          }
          try {
            // Effectue la requête AJAX
            const response = await fetch((window as any).ajax.ajax_url, {
              method: "POST",
              body: formData,
            });

            const result = await response.json();

            if (result.success && result.data.html) {
              const postsContainer = document.querySelector('.archive-news__list') as HTMLDivElement | null;
              if (postsContainer) {
                postsContainer.insertAdjacentHTML('beforeend', result.data.html);
              }
              loadMoreButton.setAttribute('data-page', nextPage.toString());
              if (!result.data.hasMore) {
                loadMoreButton.remove();
              }
            } else {
              console.error("Erreur lors du chargement des actualités :", result.data);
            }
          } catch (error) {
            console.error("Erreur réseau ou serveur :", error);
          }
        });
      }
    }
  }


}

export const archiveNews = new ArchiveNews();
